import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Breakfast from "../pages/breakfast/page";
import LunchDinner from "../pages/lunch-dinner/page";
import Beverages from "../pages/beverages/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/breakfast",
    element: <Breakfast />,
  },
  {
    path: "/lunch-dinner", 
    element: <LunchDinner />,
  },
  {
    path: "/beverages",
    element: <Beverages />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;